import { DateTime } from 'luxon';

import type { ValidationError } from '../../models/ValidationError';
import { ValidationErrors } from '../../models/ValidationErrors';
import type { AssetForm } from '../../store/forms';
import { SchemaType } from '../../store/forms/Asset-Editor/SchemaTypeOptions';
import { validateFileExtension } from './validateFileExtension';

export const validateAssetForm: (form: AssetForm) => ValidationErrors = (form) => {
  // console.log('validateAssetForm', { form });
  const errors: ValidationError[] = [];
  const regex = new RegExp('^[^A-Za-z0-9]');

  if (form.mode === 'new' && form.source !== 'ClipGroup') {
    if (form.ingestFiles.length === 0) {
      errors.push({ fieldId: 'ingestFile', message: 'A file must be selected.' });
    } else {
      const files = [];
      for (let i = 0; i < form.ingestFiles.length; i++) {
        const error = validateFileExtension(form.schemaType, form.ingestFiles[i].name);
        if (error !== null) {
          errors.push(error);
        } else {
          files.push(form.ingestFiles[i]);
        }
      }
    }
  }

  if (form.title.trim().length === 0 && !form.isBatchUploadEnable) {
    errors.push({ fieldId: 'title', message: 'Title is required.' });
  }

  // console.log('validateAssetForm', form.title);
  if (form.title.trim().length > 0 && regex.test(form.title)) {
    errors.push({ fieldId: 'title', message: 'Title should not start with a special character.' });
  }

  const { publicationDate } = form;
  if (publicationDate == null) {
    errors.push({ fieldId: 'publicationDate', message: 'Publication Date is required.' });
  }

  if (!form.schemaType) {
    errors.push({ fieldId: 'schemaType', message: 'Media Type is required.' });
  }
  if (form.schemaType && form.schemaType === SchemaType.Video) {
    // #343038 UI redesign: (UI) Category and Tags should be optional
    // if (form.categories.length === 0) {
    //   errors.push({ fieldId: 'categories', message: 'At least one category must be specified.' });
    // }
    // if (form.tags.length === 0) {
    //   errors.push({ fieldId: 'tags', message: 'At least one tag must be specified.' });
    // }

    if (form.automatedTitle.trim().length > 0 && regex.test(form.automatedTitle) && form.assetDisplayNameEnabled) {
      errors.push({ fieldId: 'automatedTitle', message: 'Display Name should not start with a special character.' });
    }

    const { embargoDate } = form;
    const { expireDate } = form;

    // #349653 per Sandy The only control (and even that should be in the UI only) should be:
    // Embargo Date <= Expiry Date for everything (create, edit of assets including subclips).
    if (embargoDate !== null && expireDate != null) {
      const embargoDt = DateTime.fromISO(embargoDate);
      const expireDt = DateTime.fromISO(expireDate);
      const isAfter = embargoDt > expireDt;
      if (isAfter) {
        errors.push({ fieldId: 'embargoDate', message: "Embargo Date can't be after the Expire Date." });
        errors.push({ fieldId: 'expireDate', message: "Embargo Date can't be after the Expire Date." });
      }
    }
  }

  return new ValidationErrors(errors);
};
